import React, { useState } from 'react';
import { Download, Loader2, Mail, RefreshCw, Undo2, CheckCircle2, XCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { downloadReceipt } from '@/lib/billingApi';
import { NoteDialog } from './NoteDialog';

const OPEN = ['initiated', 'pending', 'processing', 'needs_review'];

const Act = ({ id, busy, icon: Icon, onClick, children, testId, className = '' }) => (
  <Button size="sm" variant="outline" disabled={!!busy} onClick={onClick} className={className} data-testid={testId}>
    {busy === id ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Icon className="w-4 h-4 mr-1.5" />}{children}
  </Button>
);

export const TxnActions = ({ p, receipt, busy, run, onRefund }) => {
  const [note, setNote] = useState(null);
  const card = p.gateway === 'plugnpay' && !!p.order_id;
  const submitNote = async (text, ref) => {
    const ok = note === 'paid'
      ? await run('note', 'mark-paid', { note: text, gateway_ref: ref || undefined }, 'Marked as paid')
      : await run('note', 'mark-failed', { note: text }, 'Marked as failed');
    if (ok) setNote(null);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid="txn-actions">
      {receipt && <Act id="pdf" busy={busy} icon={Download} testId="txn-download-receipt-btn"
        onClick={() => downloadReceipt(receipt.id, receipt.number).catch((e) => toast.error(e.message))}>Receipt PDF</Act>}
      {receipt && <Act id="resend" busy={busy} icon={Mail} testId="txn-resend-receipt-btn"
        onClick={() => run('resend', 'resend-receipt', null, 'Receipt email sent')}>Resend receipt</Act>}
      {card && <Act id="reconcile" busy={busy} icon={RefreshCw} testId="txn-reconcile-btn"
        onClick={() => run('reconcile', 'reconcile', null, "Checked with Plug'n Pay")}>Check with gateway</Act>}
      {['paid', 'partially_refunded'].includes(p.status) && <Act id="refund" busy={busy} icon={Undo2} testId="txn-refund-btn"
        className="text-violet-700 border-violet-200 hover:bg-violet-50" onClick={onRefund}>Refund</Act>}
      {[...OPEN, 'failed', 'cancelled'].includes(p.status) && p.kind !== 'card_update' && <Act id="paid" busy={busy} icon={CheckCircle2} testId="txn-mark-paid-btn"
        className="text-emerald-700 border-emerald-200 hover:bg-emerald-50" onClick={() => setNote('paid')}>Mark paid</Act>}
      {OPEN.includes(p.status) && <Act id="failed" busy={busy} icon={XCircle} testId="txn-mark-failed-btn"
        className="text-red-600 border-red-200 hover:bg-red-50" onClick={() => setNote('failed')}>Mark failed</Act>}
      <NoteDialog mode={note} busy={busy === 'note'} onClose={() => setNote(null)} onSubmit={submitNote} />
    </div>
  );
};
